import React from 'react';
import { Card, CardContent } from './ui/card';
import { Star, Quote } from 'lucide-react';

const Testimonials = () => {
  const testimonials = [
    {
      name: 'Anna M.',
      age: 32,
      result: 'Schudła 15 kg w 4 miesiące',
      text: 'Paweł to prawdziwy profesjonalista! Dzięki jego indywidualnemu podejściu i wsparciu dietetycznemu udało mi się osiągnąć cel, o którym marzyłam od lat. Treningi są wymagające, ale efekty przeszły moje najśmielsze oczekiwania.',
      rating: 5
    },
    {
      name: 'Marcin N.',
      age: 28,
      result: 'Przybrał 8 kg masy mięśniowej',
      text: 'Pracuję z Pawłem od pół roku i jestem mega zadowolony. Nie tylko pomógł mi zbudować masę, ale też nauczył prawidłowej techniki i dał wiedzę, którą mogę stosować dalej. Polecam każdemu, kto chce realnych rezultatów!',
      rating: 5
    },
    {
      name: 'Karolina W.',
      age: 35,
      result: 'Poprawiła kondycję i samopoczucie',
      text: 'Po ciąży nie mogłam wrócić do formy. Paweł stworzył dla mnie plan treningowy i dietetyczny, który idealnie wpasował się w mój tryb życia z dzieckiem. Czuję się lepiej niż przed ciążą! Treningi online są super wygodne.',
      rating: 5
    },
    {
      name: 'Piotr Z.',
      age: 42,
      result: 'Wyeliminował bóle pleców',
      text: 'Przez lata pracy biurowej miałem problemy z kręgosłupem. Paweł nie tylko pomógł mi schudnąć, ale przede wszystkim nauczył prawidłowych wzorców ruchowych. Bóle pleców zniknęły, a ja czuję się o 10 lat młodszy!',
      rating: 5
    },
    {
      name: 'Magdalena L.',
      age: 26,
      result: 'Przygotowanie do zawodów fitness',
      text: 'Paweł przygotował mnie do moich pierwszych zawodów bikini fitness. Jego wiedza, doświadczenie i cierpliwość były kluczowe. Zajęłam 3 miejsce! Bez niego nie byłoby tego sukcesu. Absolutnie polecam!',
      rating: 5
    },
    {
      name: 'Tomasz W.',
      age: 38,
      result: 'Transformacja sylwetki po 40-tce',
      text: 'Myślałem, że po 40-tce już nie ma szans na dobrą formę. Paweł udowodnił mi, że się myliłem. Profesjonalne podejście, motywacja i konkretne rezultaty. Najlepsza inwestycja w siebie, jaką mogłem zrobić!',
      rating: 5
    }
  ];

  return (
    <section className="testimonials-section" id="testimonials">
      <div className="container">
        <div className="section-header">
          <h2 className="section-title">Opinie Klientów</h2>
          <p className="section-description">
            Zobacz, co mówią osoby, które osiągnęły swoje cele fitness ze mną
          </p>
        </div>
        <div className="testimonials-grid">
          {testimonials.map((testimonial, index) => (
            <Card key={index} className="testimonial-card">
              <CardContent className="testimonial-content">
                <div className="quote-icon">
                  <Quote size={32} />
                </div>
                <div className="testimonial-rating">
                  {[...Array(testimonial.rating)].map((_, i) => (
                    <Star key={i} size={20} fill="currentColor" />
                  ))}
                </div>
                <p className="testimonial-text">"{testimonial.text}"</p>
                <div className="testimonial-footer">
                  <div className="testimonial-author">
                    <p className="author-name">{testimonial.name}</p>
                    <p className="author-age">{testimonial.age} lat</p>
                  </div>
                  <div className="testimonial-result">
                    <span className="result-badge">{testimonial.result}</span>
                  </div>
                </div>
              </CardContent>
            </Card>
          ))}
        </div>
        <div className="testimonials-cta">
          <p className="cta-text">Gotowy, aby dołączyć do nich?</p>
          <button 
            className="btn-cta"
            onClick={() => document.getElementById('contact').scrollIntoView({ behavior: 'smooth' })}
          >
            Rozpocznij Swoją Transformację
          </button>
        </div>
      </div>
    </section>
  );
};

export default Testimonials;
